import { render, staticRenderFns } from "./ui-cta.vue?vue&type=template&id=f5e1d1ba&scoped=true&"
import script from "./ui-cta.vue?vue&type=script&lang=js&"
export * from "./ui-cta.vue?vue&type=script&lang=js&"
import style0 from "./ui-cta.vue?vue&type=style&index=0&id=f5e1d1ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5e1d1ba",
  null
  
)

export default component.exports